import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {LotNumberParamsModel} from "../models/cofa-widget/lot-number-params.model";

export class LotNumberSearchForm extends ObservableBaseForm<LotNumberParamsModel> {
    public get formatId(): AbstractControl {
        return this.formInstance.get("formatId") as AbstractControl;
    }

    public get lotNumber(): AbstractControl {
        return this.formInstance.get("lotNumber") as AbstractControl;
    }

    public static createForm(formBuilder: FormBuilder, initialValues: LotNumberParamsModel): LotNumberSearchForm {
        const form = formBuilder.group({
            formatId: formBuilder.control(initialValues.formatId, Validators.required),
            lotNumber: formBuilder.control(initialValues.lotNumber, Validators.required) // TODO-VTA: show validation message
        });

        return new LotNumberSearchForm(form, initialValues);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: LotNumberParamsModel,
    ) {
        super(formInstance, initialValues);
    }

    protected createChangeSubscription(): Observable<LotNumberParamsModel> {
        return merge(
            this.formatId.valueChanges,
            this.lotNumber.valueChanges
        )
        .pipe(
            switchMapTo(this.formInstance.statusChanges
                .pipe(filter(this.validate))
            ),
            map(status => this.getModel())
        );
    }

    public reset(): void {
        this.formatId.setValue("", {emitEvent: false});
        this.lotNumber.setValue("", {emitEvent: false});
    }
}
